module.exports = "<div>\r\n  <input type=\"checkbox\" [(ngModel)]=\"params.data.selected\">\r\n</div>\r\n"